import {
    UPDATE_CART,
    GET_PRODUCT_LIST,
    ADD_PRODUCT,
    UPDATE_PRODUCT,
    DELETE_PRODUCT,
    CLEAR_ALL_PRODUCT,
    SETTLE
} from "./mutation-type.js";

const name = "cart";

const state = {
    dataList: [] // 购物车列表数据
};

const getters = {
    cartCount(state) {
        let count = 0;
        state.dataList.forEach(data => {
            count = count + data.ProductList.length;
        });
        return count;
    }
};

const actions = {
    async [GET_PRODUCT_LIST]({ commit }) {
        // let url = "api/ShoppingCart/GetProductList";
        // let res = await rt.get(url);
        // let dataList = res.map(item => {
        //     item.currentIndex = -1;
        //     item.ProductList.forEach(product => {
        //         product.checked = false;
        //     });
        //     return item;
        // });
        // commit(UPDATE_CART, dataList);
    },
    async [ADD_PRODUCT]({ dispatch }, product) {
        let url = "api/ShoppingCart/AddProduct";
        await rt.post(url, product);

        dispatch(GET_PRODUCT_LIST);
    },
    async [UPDATE_PRODUCT]() {},
    async [DELETE_PRODUCT]({ dispatch }, id) {
        let url = "api/ShoppingCart/DeleteProduct?id=" + id;
        await rt.post(url);

        // dispatch(GET_PRODUCT_LIST);
    },
    async [CLEAR_ALL_PRODUCT]({ dispatch }) {
        let url = "api/ShoppingCart/ClearAllProduct";
        await rt.post(url);

        dispatch(GET_PRODUCT_LIST);
    },
    async [SETTLE]({ dispatch }, data) {
        let url = "api/ShoppingCart/Settle";
        var id = await rt.post(url, data);

        dispatch(GET_PRODUCT_LIST);

        return id;
    }
};

const mutations = {
    [UPDATE_CART](state, dataList) {
        state.dataList = dataList;
    }
};

export default {
    name,
    state,
    getters,
    actions,
    mutations
};



// WEBPACK FOOTER //
// ./src/store/cart/index.js